export default __webpack_public_path__ + "static/media/logo_wki_mobile.a788a4a7.png";